module.exports = __webpack_public_path__ + "static/media/sr.65cdb1de.svg";